import type { Comment } from "./models.js";

// A Treezor holder signs in to Aircap but speaks for the account, like a Swan member.
export const commentAuthorTeam = (author: Comment["author"]) => {
  switch (author.source) {
    case "swan":
      return "account";
    case "api":
      return "aircap";
    case "aircap":
      return author.role === "user.accountHolder" ? "account" : "aircap";
  }
};

export const commentAuthorLabel = (author: Comment["author"]) => {
  switch (author.source) {
    case "aircap":
      return author.email;
    case "swan":
      return author.name ?? author.email;
    case "api":
      return author.name;
  }
};
